import React, { useCallback } from "react";
import PropTypes from "prop-types";
import EntitiesSelector, { commonPropTypes } from "./entities-selector";
import { injectIntl } from "react-intl";

const query = `
  query SourceBrands {
    sourceBrands {
      items
      total
    }
  }
`;

const SourceBrandSelect = ({ intl, multiple = false, id = "brand", name = "brand", isInsideForm, ...props }) => {
  const handleDataFromResponse = useCallback(data => data.sourceBrands, []);
  const handleGetValue = useCallback(element => element, []);
  const handleGetLabel = useCallback(element => element, []);

  return (
    <EntitiesSelector
      isInsideForm={isInsideForm}
      id={id}
      name={name}
      queryString={query}
      onGetDataFromResponse={handleDataFromResponse}
      onGetValue={handleGetValue}
      onGetLabel={handleGetLabel}
      {...props}
    />
  );
};

SourceBrandSelect.propTypes = {
  ...commonPropTypes,
  /**
   * Valor del selector
   */
  selectedElement: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /**
   * Valor del selector
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default injectIntl(SourceBrandSelect);
